module.exports = __webpack_public_path__ + "static/media/eliza-jane-icon.90646acc.jpg";